export default function (config) {
    const headers = config.headers;

    headers["X-Request-Platform"] = "web";
    headers["X-Nonce"] = "";
    headers["X-Device-Id"] = "123555";
    headers["X-Request-Version"] = "1.5.4";

    // config.url = `/hmc_activity_server/0/0/${config.url}`;

    return Promise.resolve(config);
}